import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from "recharts";

const ImpactAnalysisPieChart = ({
  privatePercentage = 60,
  governmentPercentage = 40,
  privateInvestment = 0,
  governmentContribution = 0,
  totalInvestment = 0,
}) => {
  const data = [
    { name: "Private Sector", value: privatePercentage, color: "#4FAD5B" },
    { name: "Government", value: governmentPercentage, color: "#0092CC" },
  ];

  const renderLabel = ({
    cx,
    cy,
    midAngle,
    innerRadius,
    outerRadius,
    value,
  }) => {
    const RADIAN = Math.PI / 180;
    const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);

    return (
      <text
        x={x}
        y={y}
        fill="#050505"
        textAnchor="middle"
        dominantBaseline="central"
        fontSize="0.70581rem"
        fontWeight="500"
        fontFamily="Inter"
        fontStyle="normal"
        style={{ lineHeight: "0.88225rem" }}
      >
        {`${value}%`}
      </text>
    );
  };

  const formatCurrency = (value) => {
    return new Intl.NumberFormat('en-KE', {
      style: 'currency',
      currency: 'KES',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(value).replace('KES', 'KSh');
  };

  const renderLegend = () => {
    return (
      <div className="flex flex-col gap-[0.75rem]  font-sora">
        <div className="flex items-start gap-[0.5rem]">
          <div
            className="w-[0.5rem] h-[0.5rem] rounded-full mt-[0.25rem] flex-shrink-0"
            style={{ backgroundColor: "#4FAD5B" }}
          ></div>
          <div className="flex flex-col">
            <span className="text-[#424242] text-[0.75rem] font-[400]  ">
              Your Private Investment:
            </span>
            <span className="text-[#424242] text-[0.75rem] font-[600]">
              {formatCurrency(privateInvestment)}
            </span>
          </div>
        </div>
        <div className="flex items-start gap-[0.5rem]">
          <div
            className="w-[0.5rem] h-[0.5rem] rounded-full mt-[0.25rem] flex-shrink-0"
            style={{ backgroundColor: "#0092CC" }}
          ></div>
          <div className="flex flex-col">
            <span className="text-[#424242] text-[0.75rem] font-[400]  ">
              Government Contribution:
            </span>
            <span className="text-[#424242] text-[0.75rem] font-[600]">
              {formatCurrency(governmentContribution)}
            </span>
          </div>
        </div>
        <div className="pt-[0.75rem]">
          <div className="flex flex-col">
            <span className="text-[#424242] text-[0.75rem] font-[400]">
              Total Project Investment:
            </span>
            <span className="text-[#424242] text-[0.75rem] font-[600] ">
              {formatCurrency(totalInvestment)}
            </span>
          </div>
        </div>
      </div>
    );
  };

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      return (
        <div className="bg-white px-3 py-2 border border-gray-200 rounded shadow-lg">
          <p className="text-sm font-medium text-gray-900">{payload[0].name}</p>
          <p className="text-sm text-gray-600">{`${payload[0].value}%`}</p>
        </div>
      );
    }
    return null;
  };

  return (
    <div className="w-full flex items-start justify-start flex-col">
      <div className="text-[#1A1A1A] font-sora text-[1.25rem] font-[600] leading-[1.5rem] mb-[1rem]">
        Impact Analysis
      </div>
      <div className="w-full flex items-center gap-[2rem]">
        <div className="flex-shrink-0" style={{ width: '200px', height: '200px' }}>
          <ResponsiveContainer width="100%" height="100%">
            <PieChart>
              <Pie
                data={data}
                cx="50%"
                cy="50%"
                innerRadius={40}
                outerRadius={80}
                paddingAngle={0}
                dataKey="value"
                startAngle={90}
                endAngle={450}
                label={renderLabel}
                labelLine={false}
              >
                {data?.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={entry?.color} />
                ))}
              </Pie>
              <Tooltip content={<CustomTooltip />} />
            </PieChart>
          </ResponsiveContainer>
        </div>
        <div className="flex-1">
          {renderLegend()}
        </div>
      </div>
    </div>
  );
};

export default ImpactAnalysisPieChart;
